<template>
    <div>
        <h4>История отправки уведомлений</h4>
        <v-row>
            <v-col offset="1">
                <p class="" style="font-size: 120%" v-for="notification in notifications" :key="notification.id">
                    {{notification.text_log}}
                </p>
            </v-col>
        </v-row>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {organizationNotifications} from '@/api/organizations';

export default {
    name: 'OrganizationNotifications',
    props:{
        init_filters: {
            type: Object,
            default: () => {}
        }
    },
    data: () => ({
        filters: {},
        notifications: [],
        isFetching: false
    }),
    created(){
        this.filters = {...this.init_filters};
        this.load();
    },
    methods: {
        async load(){
            this.isFetching = true;
            try{
                let response = await organizationNotifications(this.ID_WORK_SPACE, this.ORGANIZATION_ID, this.filters);
                this.notifications.splice(0, this.notifications.length, ...response.data);
            }catch(e){
                console.log(e);
            }finally{
                this.isFetching = false;
            }
        },
    },
    computed:{
      ...mapGetters('workspace', ['ID_WORK_SPACE', 'ORGANIZATION_ID']),
    },
}
</script>